var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM7.5 9.25C7.5 8.55965 8.05965 8 8.75 8C9.44035 8 10 8.55965 10 9.25C10 9.94035 9.44035 10.5 8.75 10.5C8.05965 10.5 7.5 9.94035 7.5 9.25ZM12.5 9.25C12.5 8.55961 13.0597 8 13.75 8C14.4403 8 15 8.55961 15 9.25C15 9.94039 14.4403 10.5 13.75 10.5C13.0597 10.5 12.5 9.94039 12.5 9.25ZM17.5506 12.0076C17.961 12.0636 18.2483 12.4417 18.1923 12.8521C17.8144 15.6214 15.6251 17.8119 12.8564 18.1917C12.4461 18.248 12.0678 17.961 12.0115 17.5506C11.9552 17.1403 12.2422 16.762 12.6526 16.7057C14.7543 16.4173 16.4192 14.7514 16.7061 12.6493C16.7621 12.2389 17.1402 11.9516 17.5506 12.0076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAlt);
export default __webpack_public_path__ + "static/media/emoji-alt.10469e94f1e58be555db36381d80a380.svg";
export { ForwardRef as ReactComponent };